import { createReducer, on } from '@ngrx/store';
import { UserProfileResource } from './userprofile.model';
import { loadUserProfileSuccessAction, updateUserProfileSuccessAction } from './userprofile.actions';

export interface UserProfileState {
	userProfile: UserProfileResource;
}

export const initialState: UserProfileState = {
	userProfile: undefined,
};

export const userProfileReducer = createReducer(
	initialState,
	on(
		loadUserProfileSuccessAction,
		updateUserProfileSuccessAction,
		(state: UserProfileState, { userProfile }): UserProfileState => ({
			...state,
			userProfile,
		})
	)
);
